<template>
  <div class="popup guide-popup">
    <img :src="guideUrl" />
    <a class="close" @click="closePopup"></a>
    <a :href="googleDownload" class="download-btn google" target="_blank"></a>
    <a :href="appDownload" class="download-btn app" target="_blank"></a>
  </div>
</template>

<script type="text/javascript">
export default {
  name: "fbGuidePopup",
  data() {
    return {
      googleDownload: window.googleDownload || "",
      appDownload: window.appDownload || "",
      guideUrl: window.guideUrl || ""
    };
  },
  methods: {
    closePopup() {
      this.$parent.toggleGuidePopup();
    }
  }
};
</script>
